import PublicFormPage from './pages/PublicFormPage.tsx';
import PublicFormRequestPage from './pages/PublicFormRequestPage.tsx';
import { PUBLIC_FORM_PATH, PUBLIC_FORM_REQUEST_PATH } from './constants.ts';

export default [
    {
        path: PUBLIC_FORM_REQUEST_PATH,
        loginRequired: false,
        component: PublicFormRequestPage,
    },
    {
        path: PUBLIC_FORM_PATH,
        loginRequired: false,
        component: PublicFormPage,
    },
];
